import { daysOfWeekArray } from "../daysOfWeek";
import { SelectDropdown } from "../../types";

export const weekDaySelect: SelectDropdown = {
	selectName: 'dayOfWeek',
	defaultValue: 'all',
	minWidth: 130,
	selectMenu: [{ value: 'all', label: 'כל השבוע' }, ...daysOfWeekArray?.map(({ id, value }) => ({ value: id, label: value }))]
};